export default __webpack_public_path__ + "static/media/analytics.9e4018c3.svg";